import { app } from '../../../app';
import { Controller } from './custom-application-integration.controller';

app.component('companyCustomAppIntegration', {
    bindings: {
        applications: '<',
        appType$: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./custom-application-integration.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/custom-application-integration/custom-application-integration.component.js